import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
let zoneSelect = class zoneSelect extends Vue {
    apiRequestNum;
    get zoneData() {
        return PortraitCenterModule.zoneData;
    }
    get zoneTree() {
        return PortraitCenterModule.zoneTree;
    }
    get zoneId() {
        return PortraitCenterModule.zoneId;
    }
    handleNodeClick(node) {
        if (node.id === this.zoneData.parent.id) {
            return;
        }
        this.zoneData.parent = node;
        PortraitCenterModule.getCurrentZoneId(Number(this.zoneData.parent?.id));
    }
};
__decorate([
    Prop()
], zoneSelect.prototype, "apiRequestNum", void 0);
zoneSelect = __decorate([
    Component({
        name: 'zoneSelect',
        components: {},
        i18n: { messages: lang },
    })
], zoneSelect);
export default zoneSelect;
